import { SET_PROJECTS } from '../actionTypes'

export function setProjects(projects) {
  return {
    type: SET_PROJECTS,
    projects
  }
}
